import { spawn, Thread, Worker, Pool } from "threads";
import statusMessage from './display/status';


let workerRuntime = async function () {
    if (
      typeof WorkerGlobalScope !== "undefined" &&
      self instanceof WorkerGlobalScope
    ) { return };
    let solverWorker = await spawn(new Worker("./workers/solver.js"));
    Thread.events(solverWorker).subscribe((event) => {
      if(event.data.type == "update"){
        statusMessage.set(event.data.msg);
      }
    });
    console.log("Worker Initialized");
    return solverWorker;
};


export default workerRuntime; //run all FEM in a worker;